import { ChatShareDialog, CopyStatus } from '@/pages/aigc/pages/Agent/ChatShare/types/chatShare';
import SvgIcon from '@home/components/SvgIcon';
import React, { useEffect, useState } from 'react';
import { Modal } from 'tea-component';
import { useIntl } from 'umi';
import './index.scss';
import CommonBubble from '@home/components/CommonBubble';
import useChatShareHooks from '@/pages/aigc/pages/Agent/ChatShare/useChatShareHooks';
import { useSearchParamsAppoint } from '@/pages/aigc/hooks/useQuery';
import { useLocalState } from '../../ChatPage/hooks/useLocalState';
import { useSessionId } from '../../ChatPage/hooks/useAgentModalSata';

interface IChartShareModalProps {
  showShareChatDialog?: ChatShareDialog;
  setShowShareChatDialog: React.Dispatch<React.SetStateAction<ChatShareDialog | undefined>>;
  style?: React.CSSProperties;
}

export const ChartShareModal = ({
  showShareChatDialog,
  setShowShareChatDialog,
  style = {}
}: IChartShareModalProps) => {
  const { formatMessage } = useIntl();
  const [snapshotID, setSnapshotID] = useState<string>();
  const { template } = useSearchParamsAppoint();
  // 当前会话是否走 Skill 模式：URL 上没有 `template` 时，回退读取全局会话模式状态
  // （与 QAInput / AgentModeSelector / ChatPage 保持一致）
  const [sessionTemplateMode] = useLocalState<string>('__dba_session_template_mode__', '');
  const effectiveTemplate = (template || sessionTemplateMode) as string;
  const { sessionId } = useSessionId();
  const { handleCopyChatLink, getCopyStatusMessage } = useChatShareHooks(); 
  const [copyStatus, setCopyStatus] = useState<CopyStatus>();
  useEffect(() => {
    if(snapshotID || !showShareChatDialog) return;
  
    if(showShareChatDialog.isShowCopyDialog && showShareChatDialog.snapshotID) {
      setSnapshotID(showShareChatDialog.snapshotID);
      handleCopyChatLink(`${window.location.origin}/v2/agent/chatShare?snapshotId=${showShareChatDialog.snapshotID}${['dsReport', 'aiExcel', 'magicPoster', 'skill'].includes(effectiveTemplate) ? `&shareId=${sessionId}&template=${effectiveTemplate}` : ''}`);

      setCopyStatus(CopyStatus.DONE);
    }
    else{
      setCopyStatus(CopyStatus.ERROR);
      setShowShareChatDialog(undefined);
    }
        
  }, [handleCopyChatLink, sessionId, setShowShareChatDialog, showShareChatDialog, snapshotID, effectiveTemplate]);
  const shareChatLink = `${window.location.origin}/v2/agent/chatShare?snapshotId=${snapshotID}${effectiveTemplate && ['dsReport', 'aiExcel', 'magicPoster', 'skill'].includes(effectiveTemplate) ? `&shareId=${sessionId}&template=${effectiveTemplate}` : ''}`;

  useEffect(() => {
    if (copyStatus === undefined) return;

    const timeout = setTimeout(() => {
      setCopyStatus(undefined);
    }, 3000);

    return () => {
      clearTimeout(timeout);
    };
  }, [copyStatus]);
  
  if(showShareChatDialog?.snapshotID === undefined) return null;
  
  return (
    <Modal
      className="dba-chat-share-dialog"
      caption={formatMessage({ id: 'dba_menu_share_link' })}
      visible={showShareChatDialog?.isShowCopyDialog}
      onClose={() => setShowShareChatDialog(undefined)}
      style={{ ...style }}
    >
      <Modal.Body>
        <div className="dba-chat-share-input-wrapper">    
          <input
            id='dba-input-link'
            type="text"
            readOnly
            value={shareChatLink}
          />
          <CommonBubble
            className="dba-chat-share-copy-bubble"
            content={getCopyStatusMessage(copyStatus)}
            placementOffset={[0, 0]}
            placement={'left'}
            visible={copyStatus === CopyStatus.DONE}
            arrowPointAtCenter={true}
            overlayClassName='dba-chat-share-overlay'
          >
            <button
              disabled={copyStatus === CopyStatus.DONE}
              className="dba-input-btn dba-btn-default dba-share-link-copy-btn"
              onClick={() => {
                handleCopyChatLink(shareChatLink);
                setCopyStatus(CopyStatus.DONE);
              }}
            >
              <SvgIcon type="copy-new"></SvgIcon>
              {formatMessage({ id: 'dba_common_copy' })}
            </button>
           
          </CommonBubble>
        </div>
  
        <div className="dba-chat-share-caption">
          {formatMessage({ id: 'dba_menu_share_caption' })}
        </div>
      </Modal.Body>
    </Modal>
  );};

export default ChartShareModal;